import React from 'react'
import { Controller } from 'react-hook-form'
import { RadioGroup } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'
import { Control } from 'react-hook-form'
import { RadioGroupProps } from 'app/components/atoms/RadioGroup'

interface FormRadioGroupProps extends RadioGroupProps {
  control?: Control
  name: string
  defaultValue?: string
  error?: any
  controllerProps?: any
}

const FormRadioGroup = ({
  controllerProps,
  control,
  name,
  defaultValue,
  error,
  ...rest
}: FormRadioGroupProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <RadioGroup
          {...rest}
          value={value}
          onChanged={(value) => {
            onChange(value)
          }}
          isError={!!error}
          errorMessage={t(error?.message)}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormRadioGroup
